import { writableSessionStorage } from './writableSessionStorage';
import { addMonths, startOfDay, formatISO } from 'date-fns';

export const SORTING_KEY_PARAM_MAP: Record<IEventSortingKey, Record<string, string>> = {
	relevance_desc: {
		_sort_field: 'relevance',
		_sort_direction: 'desc'
	},
	starts_at_asc: {
		_sort_field: 'starts_at',
		_sort_direction: 'asc'
	},
	starts_at_desc: {
		_sort_field: 'starts_at',
		_sort_direction: 'desc'
	}
};

export type IEventSortingKey = 'relevance_desc' | 'starts_at_asc' | 'starts_at_desc';

export interface IEventFilterSelectionsStore {
	searchText: string;
	eventTicketsSearchText: string;
	eventSlotDateRange: {
		start: string | undefined;
		end: string | undefined;
	};
	locations: string[];
	topics: string[];
	eventTypes: string[];
	targetGroups: string[];
	sorting: IEventSortingKey;
	userLatitude?: number;
	userLongitude?: number;
}

const initEventFilterSelectionData: IEventFilterSelectionsStore = {
	eventSlotDateRange: {
		start: formatISO(startOfDay(new Date())),
		end: formatISO(addMonths(startOfDay(new Date()), 8))
	},
	searchText: '',
	eventTicketsSearchText: '',
	locations: [],
	topics: [],
	eventTypes: [],
	targetGroups: [],
	sorting: 'relevance_desc',
	userLatitude: undefined,
	userLongitude: undefined
};

const createEventFilterSelectionsStore = () => {
	const { subscribe, set, update } = writableSessionStorage(
		'eventFilterSelectionsStore',
		initEventFilterSelectionData
	);

	return {
		subscribe,
		set,
		update
	};
};

export function resetFilterSelections() {
	let filterSelections: IEventFilterSelectionsStore | undefined = undefined;
	const unsubscribe = eventFilterSelections.subscribe((data) => {
		filterSelections = {
			...data,
			locations: [],
			topics: [],
			eventTypes: [],
			targetGroups: [],
			searchText: '',
			sorting: 'relevance_desc',
			eventSlotDateRange: {
				start: formatISO(startOfDay(new Date())),
				end: formatISO(addMonths(startOfDay(new Date()), 8))
			}
		};
	});

	unsubscribe();
	if (filterSelections) {
		eventFilterSelections.set(filterSelections);
	}
}

export function resetIndexPageSearchTerm() {
	let filterSelections: IEventFilterSelectionsStore | undefined = undefined;
	const unsubscribe = eventFilterSelections.subscribe((data) => {
		filterSelections = {
			...data,

			searchText: ''
		};
	});

	unsubscribe();
	if (filterSelections) {
		eventFilterSelections.set(filterSelections);
	}
}

export const eventFilterSelections = createEventFilterSelectionsStore();
